const { get: getLocation } = require('../../location')
const findForLocation = require('./find-for-location')
const updateStockCount = require('../../utils/update-stock-count')
const mergeBatchesStock = require('../../utils/merge-batches')
const docToReport = require('./doc-to-report')
const createReport = require('../tools/create')
const getIdVersion = require('../tools/get-id-version')

module.exports = async (state, {
  locationId,
  service,
  period,
  stock = {},
  submittedAt = null,
  expiry = null,
  mergeCommits,
  mergeBatches,
  documents = {},
  partialCount = false,
  // doNotMergeCounts is used by automatic full counts as there could be a preceding count before it,
  // we do not want to merge counts but save it as its own independent count.
  doNotMergeCounts = false
}) => {
  const location = await getLocation(state, locationId, period.effectiveStartDate)
  if (!location) {
    throw new Error('Location does not exist: ' + locationId)
  }
  if (!location.services.includes(service.id)) {
    throw new Error('Location has no active service: ' + service.id)
  }

  if (partialCount && getIdVersion(service) < 2) {
    throw new Error('You can not submit a partial count for a service with id version 1')
  }

  let newReport
  if (!partialCount && !doNotMergeCounts) {
    const existingReports = await findForLocation(state, {
      locationId,
      serviceId: service.id,
      period,
      entityOptions: {rawDocs: true}
    })
    // A dated save (submittedAt) becomes the new base report, so it must
    // skip partial-count docs (e.g. from Shipsy) - they're sparse and would
    // get zero-filled for every product they didn't mention. An undated
    // save is the ONE Network single-batch PATCH, which patches whatever
    // doc is latest, partial or not, on purpose.
    const existingReport = submittedAt
      ? existingReports.filter(r => !r.partialCount).slice(-1)[0]
      : existingReports[existingReports.length - 1]
    if (existingReport) {
      newReport = updateStockCount(state, {stock, expiry, mergeCommits, mergeBatches, submittedAt}, existingReport)
    } else if (mergeBatches) {
      // First submission of a new period. Seed it from the most recent prior
      // report so unsubmitted products carry forward (see
      // update-stock-count.js). Same partial-skipping rule as above.
      const priorReports = await findForLocation(state, {
        locationId,
        serviceId: service.id,
        endDate: period.effectiveStartDate,
        entityOptions: {rawDocs: true}
      })
      const priorReport = submittedAt
        ? priorReports.filter(r => !r.partialCount).slice(-1)[0]
        : priorReports[priorReports.length - 1]
      if (priorReport) {
        stock = mergeBatchesStock(priorReport.stock, stock, period.id)
      }
    }
  }

  if (!newReport) {
    newReport = createReport({
      locationId,
      service,
      period,
      username: state.user.name,
      submittedAt,
      stock,
      expiry,
      partialCount
    })

    newReport.documents = documents
  }

  await state.dal.report.write(state, newReport)
  return docToReport(state, {doc: newReport, service, period})
}
